import ReactGA from 'react-ga';
import appConfig from '../config/app-config.json';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

ReactGA.initialize(appConfig.gaTrackingId);

const setUserId = userId => ReactGA.set({ userId });

const setPageView = page => {
    ReactGA.set({ page });
    ReactGA.pageview(page);
}

const usePageViews = () => {
    let location = useLocation();
    useEffect(() => { setPageView(location.pathname) }, [location]);
}

const ga = {
    setUserId,
    setPageView,
    usePageViews
};

export default ga;
